export default "__VITE_ASSET__CO7sKuD7__"